import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "@material-ui/core";
import {
  VendorsCreatedOnFilter , 
  VendorsFiltersComponent , 
  VendorsAdvanceSearch , 
} from "../VendorsViewComponent";

export const 
VendorsHeaderView = ({
  parentTranslationPath , 
  translationPath , 
  dateFilter , 
  setDateFilter , 
  setIsDatePickerChanged , 
  isLoading , 
  advanceSearch , 
  setActiveActionType , 
  activeActionType , 
  onFilterValuesChanged , 
  filterValuesFromAdvanceSearch , 
  setOrderBy , 
  formId , 
  setFilterSearchDto ,
  setVendorsTableFilter , 
  setFilterValuesFromAdvanceSearch , 
  setActionButtonsKey , 
  orderFilter , 
  setIsClearFiltersClicked , 
  dateRangeDefault , 
  setSearchData ,
  activeSelectedAction , 
  closeTypeDialogHandler ,
  selectedOrderBy , 
  setSearchedItem , 
  setSelectedOrderBy , 
  setIsAdvanceSearchActive , 
  isAdvanceSearchActive , 
  setActiveFormType , 
  orderBy , 
  allFormFields , 
  isAllFormFieldsLoading ,
  selectFieldsOnAdvanceSearch  , 
  setSelectFieldsOnAdvanceSearch , 
  displayOpenFileButton ,
  isDisplayVendorsData ,
  changeContactClass ,
  vendorContactClasses ,
  vendorContactClassesFilter , 
  setVendorsContactClassesFilter ,
  selectedValuesInFilters ,
  setSelectedValuesInFilters ,
  setContactClasses ,
  filterValues ,
  setFilterValues , 
  isAdvanceSearchCleared , 
  setIsAdvanceSearchCleared ,
  setIsOpenAddVendorDialog ,

}) => {
  const { t } = useTranslation(parentTranslationPath);

  return (
    <div className="d-flex-column">
      <div className="header-section">
        <div className="filter-section">
          <div className="section">
            
              <ButtonBase
                className="btns theme-solid"
                idRef="addnewVendorRef"
                id="addnewvendor"
                onClick={() => {
                  setIsOpenAddVendorDialog(true);
                }}
              >
                <span>{t(`${translationPath}add-new-vendor`)}</span>
              </ButtonBase>
          </div>
          { isDisplayVendorsData  && (
            <div className="section autocomplete-section vendor-filters-section">
              <VendorsFiltersComponent
                translationPath={translationPath}
                parentTranslationPath={parentTranslationPath}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
                dateRangeDefault={dateRangeDefault}
                setIsDatePickerChanged={setIsDatePickerChanged}
                isLoading={isLoading}
                setIsAdvanceSearchActive={setIsAdvanceSearchActive}
                changeContactClass={changeContactClass}
                vendorContactClasses={vendorContactClasses}
                vendorContactClassesFilter={vendorContactClassesFilter}
                selectedValuesInFilters={selectedValuesInFilters}
                setSelectedValuesInFilters={setSelectedValuesInFilters}
                filterValues={filterValues}
                setFilterValues={setFilterValues}
                isAdvanceSearchCleared={isAdvanceSearchCleared}
                setVendorsContactClassesFilter={setVendorsContactClassesFilter}
              />

              <VendorsAdvanceSearch
                translationPath={translationPath}
                parentTranslationPath={parentTranslationPath}
                advanceSearch={advanceSearch}
                setActiveActionType={setActiveActionType}
                activeActionType={activeActionType}
                onFilterValuesChanged={onFilterValuesChanged}
                filterValuesFromAdvanceSearch={filterValuesFromAdvanceSearch}
                setOrderBy={setOrderBy}
                formId={formId}
                setFilterSearchDto={setFilterSearchDto}
                setVendorsTableFilter={setVendorsTableFilter}
                setSelectedOrderBy={setSelectedOrderBy}
                setIsAdvanceSearchActive={setIsAdvanceSearchActive}
                isAdvanceSearchActive={isAdvanceSearchActive}
                setFilterValuesFromAdvanceSearch={
                  setFilterValuesFromAdvanceSearch
                }
                setActiveFormType={setActiveFormType}
                orderFilter={orderFilter}
                setActionButtonsKey={setActionButtonsKey}
                setIsClearFiltersClicked={setIsClearFiltersClicked}
                dateRangeDefault={dateRangeDefault}
                setSearchData={setSearchData}
                setSearchedItem={setSearchedItem}
                setDateFilter={setDateFilter}
                activeSelectedAction={activeSelectedAction}
                closeTypeDialogHandler={closeTypeDialogHandler}
                allFormFields={allFormFields}
                isAllFormFieldsLoading={isAllFormFieldsLoading}
                selectFieldsOnAdvanceSearch={selectFieldsOnAdvanceSearch}
                setSelectFieldsOnAdvanceSearch={setSelectFieldsOnAdvanceSearch}
                setSelectedValuesInFilters={setSelectedValuesInFilters}
                setContactClasses={setContactClasses}
                setFilterValues={setFilterValues}
                isAdvanceSearchCleared={isAdvanceSearchCleared}
                setIsAdvanceSearchCleared={setIsAdvanceSearchCleared}
                setVendorsContactClassesFilter={setVendorsContactClassesFilter}
              />
            </div>
          )}
        </div>
        {isDisplayVendorsData && (
          <VendorsCreatedOnFilter
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            orderFilter={orderFilter}
            selectedOrderBy={selectedOrderBy}
            setOrderBy={setOrderBy}
            setSelectedOrderBy={setSelectedOrderBy}
            orderBy={orderBy}
            formId={formId}
          />
        )}
      </div>
    </div>
  );
};
